<i18n src="./resources/locales.json"></i18n>
<template>
  <div v-if="display" class="full-height full-width d-flex flex-column align-center justify-center pa-4">
    <span>{{ $t(label) }}</span>
    <v-progress-linear indeterminate></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'EcsLoading',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      default: 'loading'
    }
  }
};
</script>

<style></style>
